import React from 'react';

const NotificationSkeleton: React.FC = () => {
  return (
    <div className="d-flex align-items-start gap-4 border-b py-4">
      <div className="skeleton-block round" style={{ width: 32, height: 32 }} />
      <div className="flex-grow-1">
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className="skeleton-block round" style={{ width: 160, height: 20 }} />
          <div className="skeleton-block round ml-4" style={{ width: 96, height: 16 }} />
        </div>
        <div className="skeleton-block round w-100 mb-2" style={{ height: 16 }} />
        <div className="skeleton-block round" style={{ width: '75%', height: 16 }} />
      </div>
    </div>
  );
};

export default NotificationSkeleton;
